/** Nine approved feature-poster images supplied by the user and optimized for web. */
export type PayekoohFeatureScreen = {
  id: string
  image: string
  title: { fa: string; en: string }
  description: { fa: string; en: string }
}

export const payekoohFeatureScreens: PayekoohFeatureScreen[] = [
  {
    id: 'share',
    image: '/images/payekooh/marketing/share-activity.webp',
    title: { fa: 'اشتراک‌گذاری تجربه‌ها', en: 'Share your adventures' },
    description: {
      fa: 'مسیرها و تجربه‌های طبیعت‌گردی را با دوستانت به اشتراک بگذار.',
      en: 'Share routes and outdoor experiences with your friends.',
    },
  },
  {
    id: 'plants',
    image: '/images/payekooh/marketing/plant-identification.webp',
    title: { fa: 'شناسایی گیاهان', en: 'Discover the flora' },
    description: {
      fa: 'گیاهان اطراف مسیرت را با قابلیت تشخیص گیاه بشناس.',
      en: 'Identify the plants you encounter along the way.',
    },
  },
  {
    id: 'offline',
    image: '/images/payekooh/marketing/offline-explore.webp',
    title: { fa: 'مسیرهای آفلاین', en: 'Offline routes' },
    description: {
      fa: 'مسیرهای دانلودشده را حتی در زمان قطع اینترنت مرور کن.',
      en: 'Explore your downloaded routes when you are offline.',
    },
  },
  {
    id: 'navigation',
    image: '/images/payekooh/marketing/live-navigation.webp',
    title: { fa: 'مسیریابی حین حرکت', en: 'On-route navigation' },
    description: {
      fa: 'روی نقشه حرکت کن و جایگاهت را نسبت به مسیر ببین.',
      en: 'See your position on the trail while navigating.',
    },
  },
  {
    id: 'live',
    image: '/images/payekooh/marketing/live-location.webp',
    title: { fa: 'اشتراک موقعیت زنده', en: 'Live location sharing' },
    description: {
      fa: 'موقعیت زنده و تنظیمات اشتراک‌گذاری مسیر را مدیریت کن.',
      en: 'Manage live-location sharing and your safety options.',
    },
  },
  {
    id: 'preview',
    image: '/images/payekooh/marketing/route-preview.webp',
    title: { fa: 'پیش‌نمایش مسیر', en: 'Route preview' },
    description: {
      fa: 'قبل از شروع، نقشه و مشخصات اصلی مسیر را بررسی کن.',
      en: 'Check the map and route details before heading out.',
    },
  },
  {
    id: 'filters',
    image: '/images/payekooh/marketing/trail-filters.webp',
    title: { fa: 'فیلتر هوشمند مسیرها', en: 'Find the right trail' },
    description: {
      fa: 'با فیلترهای کاوش، گزینه‌های مناسب برنامه‌ات را پیدا کن.',
      en: 'Refine your trail search using detailed explore filters.',
    },
  },
  {
    id: 'explore',
    image: '/images/payekooh/marketing/route-discovery.webp',
    title: { fa: 'کشف مسیرهای تازه', en: 'Explore new routes' },
    description: {
      fa: 'مسیرهای تازه را جست‌وجو کن و برای ماجراجویی بعدی الهام بگیر.',
      en: 'Browse new routes and find inspiration for your next adventure.',
    },
  },
  {
    id: 'stats',
    image: '/images/payekooh/marketing/ascent-stats.webp',
    title: { fa: 'آمار و تحلیل مسیر', en: 'Activity insights' },
    description: {
      fa: 'نقشه مسیر، پروفایل ارتفاع و جزئیات حرکت را یک‌جا ببین.',
      en: 'Review route maps, elevation profiles and activity details.',
    },
  },
]
